import React from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
import { useTranslation } from 'react-i18next';
import { translatedCustomCtaLabel } from '../../../utils/translatedCustomCtaLabels';
import type { VendorCtaSelectorProps } from '../VendorCtaSelector';

const RoadsterCta = ({ ctaDetails, variant, vin }: VendorCtaSelectorProps) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const { actionTypeRoadster, ctaRoadsterLabelEnglish, ctaRoadsterLabelFrench } = ctaDetails;
  const { hasCustomLabel, customLabel } = translatedCustomCtaLabel(
    ctaRoadsterLabelEnglish,
    ctaRoadsterLabelFrench,
    lang,
  );

  // Implemented defaults if no custom label is provided
  const paymentOptionsDefaultLabel = t(
    'vehiclePricingBar.vendorCtaDefaultLabels.roadster.paymentOptions',
  );
  const startBuyingDefaultLabel = t(
    'vehiclePricingBar.vendorCtaDefaultLabels.roadster.startBuying',
  );

  // Choose the default label based on the action type
  // NOTE: actionTypeRoadster values are in english: "See payment options" or "Start buying process"
  const defaultLabel =
    actionTypeRoadster === 'See payment options'
      ? paymentOptionsDefaultLabel
      : startBuyingDefaultLabel;

  const ctaLabel = hasCustomLabel && customLabel ? customLabel : defaultLabel;

  return (
    <TextButton
      className="roadster-btn"
      variant={variant}
      href={`${ctaDetails.ctaRoadsterUrl}${vin}`}
      data-testid="roadster"
    >
      {ctaLabel}
    </TextButton>
  );
};

export default RoadsterCta;
